import { ReactElement, useEffect, useState } from 'react'
import {
  FlexWrapper,
  PageWrapper,
  SectionTitle,
  TableWrapper,
  TableHeader,
  TableFooter,
  Button,
  Loader,
  TostMessage,
} from '../../../../components'
import strings from '../../../../locale/en'
import { BatchFilterSection, BatchAction, TableRow } from '../subcomponents'
import Table from 'react-bootstrap/Table'
import { tableHeader } from './const'
import { useHistory } from 'react-router'
import ROUTES from '../../../../const/routes'
import { getInstitutes } from '../../../../redux/coachingCenter/actions'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { getBranchDropdown, getInstituteDropdown } from '../../../../helpers'
import {
  getAllBatches,
  setFormValues,
  deleteBatch,
  resetError,
  setSelectedBatch
} from '../../../../redux/batch/action'
import { getBranchesByInstitute } from '../../../../redux/branch/action'
import { SearchCriteria } from '../typing'
import { AddBatchForm } from '../../../../redux/batch/types'
import { ROLE } from '../../../../helpers/determineMenu'
import { setHours, setMinutes } from 'date-fns'
import { FormBackWrapper } from '../../User/subcomponents'

const BatchList = (): ReactElement => {
  const {
    institutes,
    batches,
    branches,
    batchPageSize,
    currentPage,
    isLoading,
    error,
    role = '',
    userDetail
  } = useSelector(
    (state: RootState) => ({
      institutes: state.coachingCenter.institutes,
      batches: state.batch.batches,
      batchPageSize: state.batch.pageSize,
      currentPage: state.batch.currentPage,
      branches: state.branch.branches,
      isLoading: state.batch.isLoading,
      error: state.batch.error,
      role: state.user.userInfo?.role,
      userDetail: state.user?.userInfo?.userDetail
    }),
    shallowEqual
  )
  const [selectedCoachingCenter, setSelectedCoachingCenter] = useState(
    userDetail?.coachingCenterId || ''
  )
  const [selectedBranch, setSelectedBranch] = useState('')
  const instituteList = institutes ? getInstituteDropdown(institutes) : []
  const branchList = branches ? getBranchDropdown(branches) : []
  const dispatch = useDispatch()
  const history = useHistory()

  const {
    menu: {
      batch: { batchListing, add }
    }
  } = strings

  const fetchBatch = (pageNumber: number) => {
    const searchCriteria: SearchCriteria = {}
    if (selectedCoachingCenter) {
      searchCriteria.coachingCenterId = selectedCoachingCenter
    }

    if (selectedBranch) {
      searchCriteria.coachingCenterBranchId = selectedBranch
    }

    dispatch(
      getAllBatches({
        pageNumber: pageNumber,
        pageSizeNumber: 10,
        searchCriteria: searchCriteria
      })
    )
  }

  const getFormattedDate = (time: string) => {
    let [hours, minutes] = time.split(':')
    let formattedDate = setHours(new Date(), Number(hours))
    formattedDate = setMinutes(formattedDate, Number(minutes))
    return formattedDate
  }

  useEffect(() => {
    if (role === ROLE.BRANCH_ADMIN) {
      dispatch(
        getAllBatches({
          pageNumber: 1,
          pageSizeNumber: 10,
          searchCriteria: {
            coachingCenterId: userDetail?.coachingCenterId,
            coachingCenterBranchId: userDetail?.branchIds[0] || ''
          }
        })
      )
    } else if (role === ROLE.INSTITUTE_ADMIN) {
      dispatch(
        getAllBatches({
          pageNumber: 1,
          pageSizeNumber: 10,
          searchCriteria: {
            coachingCenterId: selectedCoachingCenter
          }
        })
      )
      dispatch(getBranchesByInstitute(selectedCoachingCenter))
    } else {
      dispatch(getInstitutes())
      fetchBatch(1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper id="container">
      <FlexWrapper justifyContent="space-between" hasBorder>
        <SectionTitle title={batchListing} />
        <Button onClick={() => history.push(ROUTES.BATCH_ADD)}>{add}</Button>
      </FlexWrapper>
      <TostMessage
        show={!!error}
        onCloseHandler={() => dispatch(resetError())}
        message={error}
      />
      <BatchFilterSection
        role={role}
        instituteList={instituteList}
        handleinstituteSelect={(item) => {
          dispatch(
            getAllBatches({
              pageNumber: 1,
              pageSizeNumber: 10,
              searchCriteria: {
                coachingCenterId: item?.id
              }
            })
          )
          dispatch(getBranchesByInstitute(item?.id))
          setSelectedCoachingCenter(item?.id)
        }}
        branchList={branchList}
        handleBranchSelect={(item) => {
          dispatch(
            getAllBatches({
              pageNumber: 1,
              pageSizeNumber: 10,
              searchCriteria: {
                coachingCenterId: selectedCoachingCenter,
                coachingCenterBranchId: item?.id
              }
            })
          )
          setSelectedBranch(item?.id)
        }}
      />
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <FormBackWrapper>
            <TableWrapper>
              <Table size="sm" responsive="sm">
                <TableHeader>
                  <TableRow>
                    {tableHeader?.map((header, index) => (
                      <th key={`complete-session-header-${index}`}>{header}</th>
                    ))}
                  </TableRow>
                </TableHeader>
                <tbody>
                  {batches.map((batch, index) => {
                    const {
                      coachingCentre,
                      coachingCentreBranch,
                      additionalCourseId,
                      batchName,
                      course,
                      batchStartDate,
                      batchEndDate,
                      startTiming,
                      endTiming,
                      batchSize,
                      description,
                      id,
                      status
                    } = batch

                    const { coachingCentreName, id: coachingCenterId } =
                      coachingCentre || {}
                    const { branchName, id: coachingCenterBranchId } =
                      coachingCentreBranch || {}
                    const { courseName, id: courseId } = course || {}

                    return (
                      <TableRow key={`batch-list-${index}`}>
                        <td>{coachingCentreName}</td>
                        <td>{branchName}</td>
                        <td>{batchName}</td>
                        <td>{courseName}</td>
                        <td>{batchStartDate}</td>
                        <td>{batchEndDate}</td>
                        <td>{startTiming}</td>
                        <td>{endTiming}</td>
                        <td>{batchSize}</td>
                        <td>{description}</td>
                        <td>
                          <BatchAction
                            handleDelete={() => {
                              dispatch(
                                deleteBatch({
                                  batchId: id
                                })
                              )
                            }}
                            handleEdit={() => {
                              const formValues: AddBatchForm = {
                                coachingCenterId,
                                coachingCenterBranchId,
                                courseId,
                                additionalCourseId,
                                batchName,
                                batchSize,
                                batchStartDate: new Date(batchStartDate),
                                batchEndDate: new Date(batchEndDate),
                                startTiming: getFormattedDate(startTiming),
                                endTiming: getFormattedDate(endTiming),
                                description,
                                id,
                                status
                              }
                              dispatch(setFormValues(formValues))
                              history.push(ROUTES.EDIT_BATCH)
                            }}
                            handleView={() => {
                              dispatch(setSelectedBatch(batch))
                              history.push(ROUTES.VIEW_BATCH)
                            }}
                          />
                        </td>
                      </TableRow>
                    )
                  })}
                </tbody>
              </Table>
              <TableFooter
                handlePrevious={(pageNumber: number) => {
                  fetchBatch(pageNumber)
                }}
                handleNext={(pageNumber: number) => {
                  fetchBatch(pageNumber)
                }}
                currentPage={currentPage + 1}
                totalPages={batchPageSize}
              />
            </TableWrapper>
          </FormBackWrapper>
        </div>
      )}
    </PageWrapper>
  )
}

export default BatchList
